import React from 'react';
import './Footer.css';
import logo from './logo1.png';

const Footer = () => {

    // Proxy function to trigger Navbar navigation
    const handleNav = (e, targetId) => {
        e.preventDefault();
        const navbarLink = document.querySelector(`.nav-links a[href="${targetId}"]`);
        if (navbarLink) {
            navbarLink.click();
            window.scrollTo(0, 0);
        }
    };

    return (
        <footer className="footer-professional">
            <div className="footer-container">

                {/* Top Section: Grid Layout */}
                <div className="footer-top">

                    {/* Column 1: Brand & Tagline */}
                    <div className="footer-col brand-col">
                        <img src={logo} alt="GoPt Logo" className="footer-logo-lg" />
                        <p className="brand-tagline">
                            Elevating Physiotherapy with advanced technology and personalized care.
                        </p>
                    </div>

                    {/* Column 2: Quick Links */}
                    <div className="footer-col links-col">
                        <h4 className="footer-heading">Explore</h4>
                        <ul className="footer-links">
                            <li><a href="#home" onClick={(e) => handleNav(e, '#home')}>Home</a></li>
                            <li><a href="#about" onClick={(e) => handleNav(e, '#about')}>About Us</a></li>
                            <li><a href="#doctors" onClick={(e) => handleNav(e, '#doctors')}>Our Team</a></li>
                            <li><a href="#technology" onClick={(e) => handleNav(e, '#technology')}>Technology</a></li>
                            <li><a href="#contact" onClick={(e) => handleNav(e, '#contact')}>Contact</a></li>
                        </ul>
                    </div>

                    {/* Column 3: Contact Info */}
                    <div className="footer-col contact-col">
                        <h4 className="footer-heading">Visit Us</h4>
                        <ul className="contact-list">
                            <li>
                                <span className="contact-value">Cuffe Parade</span>
                                <span className="contact-label">+91 9326186695</span>
                            </li>
                            <li>
                                <span className="contact-value">Walkeshwar</span>
                                <span className="contact-label">+91 8369903928</span>
                            </li>
                            <li>
                                <span className="contact-value">Warden Court</span>
                                <span className="contact-label">+91 8779167772</span>
                            </li>
                        </ul>
                    </div>

                    {/* Column 4: Newsletter / CTA (Optional, using for Socials & Legal here) */}
                    <div className="footer-col social-col">
                        <h4 className="footer-heading">Connect</h4>
                        <div className="social-icons-row">
                            <a href="https://instagram.com/thegopt" target="_blank" rel="noreferrer" aria-label="Instagram" className="social-btn">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                            </a>
                            <a href="https://www.facebook.com/share/1CimFuQigr/" target="_blank" rel="noreferrer" aria-label="Facebook" className="social-btn">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                            </a>
                            <a href="https://youtube.com/@dr.samphysio" target="_blank" rel="noreferrer" aria-label="YouTube" className="social-btn">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="currentColor" stroke="none"></polygon></svg>
                            </a>
                        </div>
                        <a href="#contact" onClick={(e) => handleNav(e, '#contact')} className="footer-cta-btn">Book Appointment</a>
                    </div>

                </div>

                <div className="footer-divider"></div>

                {/* Bottom Section: Copyright & Developer Credits */}
                <div className="footer-bottom">
                    <p className="copyright-text">
                        &copy; {new Date().getFullYear()} GoPt. All rights reserved.
                    </p>

                    <div className="developer-credits">
                        <span className="dev-label">Developed by</span>
                        <div className="dev-names">
                            <span className="dev-wrapper">
                                <span className="dev-name">Dev Jadhav</span>
                                {/* Social Popup for Dev 1 */}
                                <div className="dev-socials-popup">
                                    <a href="https://instagram.com/devjads" target="_blank" rel="noreferrer" title="Instagram">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                                        <span>@devjads</span>
                                    </a>
                                    <a href="mailto:devjads@gmail.com" title="Email">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                                        <span>devjads@gmail.com</span>
                                    </a>
                                </div>
                            </span>
                            <span className="separator">&</span>
                            <span className="dev-wrapper">
                                <span className="dev-name">Aditya Deshpande</span>
                                {/* Social Popup for Dev 2 */}
                                <div className="dev-socials-popup">
                                    <a href="https://instagram.com/adtyxd" target="_blank" rel="noreferrer" title="Instagram">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                                        <span>@adtyxd</span>
                                    </a>
                                    <a href="mailto:adityaa1722@gmail.com" title="Email">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                                        <span>adityaa1722@gmail.com</span>
                                    </a>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default Footer;
